"use client";
import { Carousel } from "antd";
import { useEffect, useState, useRef } from "react";
import { throttle } from "@/utils/tools";
import { CarouselEffect } from "antd/es/carousel";
import Image from "next/image";
import useMobileDetect from "@/hooks/useMobileDetect";
import "./style/ImageCard.css";

export type ProductCardProps = {
  navBgIconSize?: number;
  navIconSize?: number;
  container?: string;
  img?: any[];
  height?: string;
};

export const ImageCard: React.FC<ProductCardProps> = ({
  img = [""],
  navBgIconSize = "19%",
  navIconSize = 26,
  height = "h-720",
  ...props
}) => {
  const isMobile = useMobileDetect();
  const [effect, setEffect] = useState<CarouselEffect>("scrollx");
  const [autoSwitching, setAutoSwitching] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const carouselRef = useRef<any>(null);

  let isClickValue = false;

  // 通过 ref 调用 Carousel 的 next() 方法
  const goToNext = throttle((index: number) => {
    setTimeout(() => {
      if (carouselRef.current) {
        carouselRef.current.goTo(index || 1);
      }
    }, 100);
  }, 500);

  // 通过 ref 调用 Carousel 的 next() 方法
  const goToPrev = throttle((index: number) => {
    setTimeout(() => {
      if (carouselRef.current) {
        carouselRef.current.goTo(index || 0);
      }
    }, 100);
  }, 500);

  useEffect(() => {
    if (autoSwitching) {
      setTimeout(() => {
        !isClickValue && goToNext(1);
      }, 100);
    } else {
      setTimeout(() => {
        !isClickValue && goToPrev(0);
      }, 100);
    }
  }, [autoSwitching]);

  return (
    <div className={`${props?.container} ImageCard`}>
      <div>
        <div
          style={{ position: "relative" }}
          onMouseLeave={(e) => {
            if (carouselIndex === 0 || carouselIndex === 1) {
              !isClickValue && setEffect("fade");
              setAutoSwitching(false);
            }
          }}
          onMouseEnter={(e) => {
            if (carouselIndex === 0 || carouselIndex === 1) {
              !isClickValue && setEffect("fade");
              setAutoSwitching(true);
            }
          }}
        >
          {!isMobile && img.length > 1 && (
            <div
              style={{
                position: "absolute",
                zIndex: 999,
                top: "50%",
                marginTop: `calc(-${navBgIconSize} / 2)`,
                width: 32,
                height: 48,
              }}
              onClick={(e) => {
                carouselRef.current.prev();
                e.preventDefault();
              }}
              onMouseEnter={(e) => {
                setEffect("scrollx");
              }}
              onMouseLeave={(e) => {
                setEffect("fade"); // 切换为渐隐效果
              }}
            >
              <div
                className="navShow"
                style={{
                  width: "100%",
                  height: "100%",
                }}
              >
                <iconpark-icon
                  icon-id="left"
                  size={`${navIconSize}`}
                  name="left"
                  color={"#402C22"}
                />
              </div>
            </div>
          )}
          <Carousel
            dots={false}
            ref={carouselRef}
            effect={effect}
            speed={500}
            easing="ease-in-out"
            beforeChange={(currentSlide, nextSlide) => {
              setTimeout(() => {
                setCarouselIndex(nextSlide);
              }, 550);
            }}
          >
            {img.map((item, idx) => (
              <div key={item} className={`${height} relative w-full overflow-hidden`}>
                <Image
                  src={item}
                  alt={item}
                  layout="fill"
                  objectFit="cover"
                  objectPosition="20% 80%"
                />
              </div>
            ))}
          </Carousel>
          <div className="">
            <div className="navShow absolute bottom-0 z-50 flex h-3 w-[100%] items-center bg-[#dbdbdb] text-white">
              {img && img.length > 1
                ? img.map((item, index) => {
                    return (
                      <div
                        key={index + "line_point"}
                        style={{ width: `calc(100% / ${img.length})` }}
                        className={`${index == carouselIndex ? "bg-[#222]" : ""} h-full`}
                      ></div>
                    );
                  })
                : false}
            </div>
          </div>
          {/* 右箭头 */}
          {!isMobile && img.length > 1 && (
            <div
              style={{
                position: "absolute",
                zIndex: 999,
                right: 0,
                top: "50%",
                marginTop: `calc(-${navBgIconSize} / 2)`,
                width: 32,
                height: 48,
              }}
              onClick={(e) => {
                carouselRef.current.next();
                e.preventDefault();
              }}
              onMouseEnter={(e) => {
                setEffect("scrollx");
              }}
              onMouseLeave={(e) => {
                setEffect("fade");
              }}
            >
              <div
                className="navShow"
                style={{
                  width: "100%",
                  height: "100%",
                }}
              >
                <iconpark-icon
                  icon-id="right"
                  size={`${navIconSize}`}
                  name="right"
                  color={"#402C22"}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
